import { useState } from "react";
import ThankYou from "../ThankYou";
import { submitToWeb3Forms } from "@/lib/web3forms";

export default function VerifyForm() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await submitToWeb3Forms(e.currentTarget, {
        subject: "New representative verification request — MTS website",
        fromName: "MTS Website — Verify Form",
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <ThankYou
        testId="verify-thank-you"
        heading="Thank you — we've received your verification request."
        body="A team member will review your details and follow up to confirm whether the representative is associated with Maritime Thermal Solutions. If your matter is urgent, please call (902) 706-6287."
      />
    );
  }

  return (
    <form onSubmit={onSubmit} className="space-y-5" data-testid="verify-form">
      <input type="checkbox" name="botcheck" tabIndex="-1" autoComplete="off" className="hidden" aria-hidden="true" />
      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label htmlFor="v-name" className="field-label">Your full name</label>
          <input id="v-name" name="name" type="text" required className="field-input" autoComplete="name" data-testid="verify-input-name" />
        </div>
        <div>
          <label htmlFor="v-phone" className="field-label">Phone number</label>
          <input id="v-phone" name="phone" type="tel" required className="field-input" autoComplete="tel" data-testid="verify-input-phone" />
        </div>
        <div className="sm:col-span-2">
          <label htmlFor="v-email" className="field-label">Email</label>
          <input id="v-email" name="email" type="email" required className="field-input" autoComplete="email" data-testid="verify-input-email" />
        </div>
        <div>
          <label htmlFor="v-rep-name" className="field-label">Representative name <span className="text-slate-400 font-normal">(if known)</span></label>
          <input id="v-rep-name" name="rep_name" type="text" className="field-input" data-testid="verify-input-rep-name" />
        </div>
        <div>
          <label htmlFor="v-rep-id" className="field-label">Representative ID <span className="text-slate-400 font-normal">(if known)</span></label>
          <input id="v-rep-id" name="rep_id" type="text" className="field-input" data-testid="verify-input-rep-id" />
        </div>
        <div className="sm:col-span-2">
          <label htmlFor="v-address" className="field-label">Address or area where the visit happened</label>
          <input id="v-address" name="address" type="text" required className="field-input" autoComplete="street-address" data-testid="verify-input-address" />
        </div>
        <div>
          <label htmlFor="v-date" className="field-label">Date of visit</label>
          <input id="v-date" name="visit_date" type="date" className="field-input" data-testid="verify-input-date" />
        </div>
      </div>

      <div>
        <label htmlFor="v-message" className="field-label">Message</label>
        <textarea id="v-message" name="message" className="field-textarea" placeholder="Anything you'd like us to know about the visit." data-testid="verify-input-message" />
      </div>

      {error && (
        <p className="text-sm text-red-600" role="alert" data-testid="verify-error">{error}</p>
      )}

      <div className="pt-1">
        <button type="submit" className="btn-primary" disabled={submitting} data-testid="verify-submit">
          {submitting ? "Sending…" : "Submit verification request"}
        </button>
        <p className="mt-3 text-xs text-slate-500">
          We respond during business hours (Mon–Fri, 9:00–5:00). For urgent concerns, call (902) 706-6287.
        </p>
      </div>
    </form>
  );
}
